import axios from '../../utils/axios';

export const uploadCoverRequest = (
    file: File,
    params: { bundle_id?: number | string; set_as_cover?: number | string } = {}
) => {
    const data = new FormData();
    const url = `v1/cabinet/upload-material-cover/${params.bundle_id}`;

    data.append('file', file, file.name);
    data.append('type', 'cover');

    return axios.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};
